// src/components/UserCreate.js

import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import UserService from '../../services/UserService';
import { useNavigate } from 'react-router-dom';

const UserCreate = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [roleId, setRoleId] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [countryId, setCountryId] = useState('');
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [countries, setCountries] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoles();
    fetchDepartments();
    fetchCountries();
  }, []);

  const fetchRoles = async () => {
    try {
      const data = await UserService.getRoles();
      setRoles(data);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const data = await UserService.getDepartments();
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const data = await UserService.getCountries();
      setCountries(data);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await UserService.create({
        first_name: firstName,
        last_name: lastName,
        email,
        role_id: roleId,
        department_id: departmentId,
        country_id: countryId,
      });
      Swal.fire('Created!', 'User created successfully.', 'success');
      navigate('/users'); // Redirect back to user list
    } catch (error) {
      console.error('Error creating user:', error);
      Swal.fire('Error!', 'An error occurred while creating the user.', 'error');
    }
  };

  const handleCancel = () => {
    navigate('/users'); // Redirect back to user list
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Create User</h4>
              <p className="card-description">Add a new user</p>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="roleId">Role</label>
                  <select
                    id="roleId"
                    className="form-control form-control-sm"
                    value={roleId}
                    onChange={(e) => setRoleId(e.target.value)}
                    required
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="departmentId">Department</label>
                  <select
                    id="departmentId"
                    className="form-control form-control-sm"
                    value={departmentId}
                    onChange={(e) => setDepartmentId(e.target.value)}
                    required
                  >
                    <option value="">Select Department</option>
                    {departments.map((department) => (
                      <option key={department.id} value={department.id}>
                        {department.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="countryId">Country</label>
                  <select
                    id="countryId"
                    className="form-control form-control-sm"
                    value={countryId}
                    onChange={(e) => setCountryId(e.target.value)}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <button type="submit" className="btn btn-primary btn-sm mr-2">
                  <i className="ti-check menu-icon"></i> Create
                </button>
                <button type="button" className="btn btn-light btn-sm" onClick={handleCancel}>
                  <i className="ti-close menu-icon"></i> Cancel
                </button>
              </form>
            </div>
            <div className="card-footer text-muted">
              Please fill out the required fields to create a new user.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCreate;
